export const courses = [
  {
    id: "nextjs-storybook",
    name: "NextJS: Documenting Your Front-end with Storybook",
    institution: "Alura",
    issued: "September 2023",
    workload: "6 hours",
    url: "https://cursos.alura.com.br/certificate/e4ff0bca-c101-49d6-b4be-bc26755984af",
    description:
      "Documenting front-ends, Storybook features with React, themes and providers, customizing Storybook, deployment and final tips.",
  },
  {
    id: "react-design-system-tailwind",
    name: "React: Creating a Design System with TailwindCSS",
    institution: "Alura",
    issued: "September 2023",
    workload: "12 hours",
    url: "https://cursos.alura.com.br/certificate/29a6f1c1-29a5-4afb-b8d4-532902fc299d",
    description:
      "Getting started, creating interactive documentation, importing design tokens, the button component and other components.",
  },
  {
    id: "nextjs-tour",
    name: "Next.js: A Tour of Next.js",
    institution: "Alura",
    issued: "September 2023",
    workload: "10 hours",
    url: "https://cursos.alura.com.br/certificate/f044702b-e9eb-4eff-ac9f-ca2762449635",
    description:
      "Pages with Next.js, additional features, full-stack considerations and deployment tips.",
  },
  {
    id: "nextjs-architecture",
    name: "Next.js: Working with Front-end Architecture",
    institution: "Alura",
    issued: "September 2023",
    workload: "8 hours",
    url: "https://cursos.alura.com.br/certificate/b2d4e3b1-3a0c-42ea-9b1f-81b815aca119",
    description:
      "Tour of architecture and monorepos, structuring the base, shared linter and test configurations.",
  },
  {
    id: "nextjs-exploring",
    name: "Next.js: Exploring the Framework",
    institution: "Alura",
    issued: "September 2023",
    workload: "8 hours",
    url: "https://cursos.alura.com.br/certificate/682a63f1-c292-4fc1-af45-77a866d3cd2e",
    description:
      "Getting to know Next.js, build and SEO, styling, dynamic data and publishing.",
  },
  {
    id: "git-github",
    name: "Git and GitHub",
    institution: "Dio",
    issued: "June 2021",
    workload: "5 hours",
    url: "https://www.dio.me/certificate/EEDC0B77/share",
    description:
      "Git introduction, command line, GitHub basics, merges and conflict resolution.",
  },
  {
    id: "react-redux",
    name: "React + Redux",
    institution: "Udemy",
    issued: "March 2021",
    workload: "49.5 hours",
    url: "https://www.udemy.com/certificate/UC-47d71489-b422-44ba-a359-faf6ffd7371d/?utm_campaign=email&utm_source=sendgrid.com&utm_medium=email",
    description:
      "React course with Redux, Webpack, full-stack application development and componentization.",
  },
  {
    id: "javascript-node",
    name: "JavaScript and Node.js",
    institution: "Udemy",
    issued: "March 2021",
    workload: "22 hours",
    url: "https://www.udemy.com/certificate/UC-aeb01951-d83e-4ca0-ad12-e0a1f29224f9/",
    description:
      "JavaScript from basic to advanced, OOP, web programming with Node, logic, regex and DOM.",
  },
  {
    id: "computer-technician",
    name: "Computer Technician",
    institution: "Microlins",
    issued: "August 2016",
    workload: "89 hours",
    url: null,
    description:
      "Assembly and maintenance of computers with foundations in hardware and software.",
  },
];
